"use client";

import React, { createContext, useContext, useState, useEffect } from "react";

import Cookies from "js-cookie";

interface RoleContextType {
  role: string;
  setRole: (role: string) => void;
  isRoleLoaded: boolean;
}

const RoleContext = createContext<RoleContextType | undefined>(undefined);

export const RoleProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [role, setRole] = useState("");
  const [isRoleLoaded, setIsRoleLoaded] = useState(false);

  useEffect(() => {
    const storedRole = Cookies.get("role") || "";

    setRole(storedRole);
    setIsRoleLoaded(true);
  }, []);

  return (
    <RoleContext.Provider
      value={{
        role,
        setRole,
        isRoleLoaded,
      }}
    >
      {children}
    </RoleContext.Provider>
  );
};

export const useRole = () => {
  const context = useContext(RoleContext);

  if (!context) {
    throw new Error("useRole must be used within a RoleProvider");
  }

  return context;
};
